import { render, staticRenderFns } from "./ProgramInquiryDialog.vue?vue&type=template&id=a1b78688"
import script from "./ProgramInquiryDialog.vue?vue&type=script&lang=js"
export * from "./ProgramInquiryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports